import { BoxContainer } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { uiConfig } from '../../../services/config';

export function TryOtherShoe(): JSX.Element {
  const { t } = useTranslation();

  return (
    <BoxContainer>
      <span
        style={{
          fontWeight: uiConfig.styles.fontWeights.bold,
          fontSize: '21px',
          opacity: '0.5',
        }}
      >
        {t('tryOtherShoe')}
      </span>
      <span
        style={{
          fontWeight: uiConfig.styles.fontWeights.regular,
          fontSize: '16px',
          opacity: '0.5',
          paddingTop: '16px',
        }}
      >
        {t('tryOtherShoeDescription')}
      </span>
    </BoxContainer>
  );
}
